<a
	*ngIf="(isScantronLicense | async) === false && legalNoticeService.isVisible"
	class="text-muted fs-6 fw-bold mx-1"
	[href]="link | transloco"
	[attr.data-cy]="'legalNotice-' + id"
	target="_blank"
>
	{{ text | transloco }}
</a>
